<template>
  <a
    class="root"
    :href="item.link"
    target="_blank"
    rel="noopener"
    :aria-label="item.title"
    ref="link"
    @tap="handleTap"
  >
    <article class="card">
      <div class="image-box">
        <ResponsiveImg
          class="image"
          :src="item.imageId"
          :alt="item.title"
        />
      </div>
      <div class="text-box">
        <div class="text-box__type_primary">
          <p class="text-box__scope typ__size_sm typ__tracking_loose typ__style_uppercase">
            <span>{{ item.scope }}</span>
            <span> / </span>
            <time class="typ__style_bold" :datetime="datetime">{{ item.date }}</time>
          </p>
          <h1 class="title typ__size_lg typ__style_bold">{{ item.title }}</h1>
        </div>
      </div>
    </article>
  </a>
</template>

<script>
import ResponsiveImg from '@/components/ResponsiveImg'

export default {
  name: 'SliderCard',
  props: ['item'],
  components: {
    ResponsiveImg
  },
  computed: {
    datetime: function () {
      if (!this.item.date.indexOf('–')) return this.item.date

      return this.item.date.split('–').join('/')
    }
  },
  methods: {
    handleTap: function () {
      this.$refs.link.click()
    }
  }
}
</script>

<style scoped lang="scss">
.root {
  font-size: 1rem;
  text-decoration: none;
}

.card {
  position: relative;
  width: calc-interpolation(getEm($sz__site-min-width), 11em, getEm($sz__site-max-width), 16em);
  height: calc-interpolation(getEm($sz__site-min-width), 10.5em, getEm($sz__site-max-width), 9.5em);
  border: $sz__border-width solid $clr__border;
  border-radius: .75em;
  box-shadow: 0 0.05em 0.1em rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;

  &:hover {
    .image-box::after {
      opacity: 1;
    }

    .image {
      transform: scale(1.1);
    }

    .text-box {
      transform: translateY(0.5em);
    }
  }
}

.image-box {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 60%;
  overflow: hidden;

  &::after {
    position: absolute;
    width: 100%;
    height: 100%;
    box-shadow: inset 0 0 2em rgba(0, 0, 0, 0.2);
    opacity: 0;
    transition: opacity $tm__fast-animation;
    content: "";
  }
}

.image {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  margin: auto 0;
  will-change: transform;
  transition: transform $tm__fast-animation;
}

.text-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50%;
  padding: 0.5em 1em;
  background: $clr__bg;
  border-top: $sz__border-width solid $clr__border;
  will-change: transform;
  transition: transform $tm__fast-animation;
}

.text-box__type_primary {
  will-change: transform;
  transition: transform $tm__fast-animation;
}

.text-box__scope {
  margin-bottom: 0;
}

.text-box__type_secondary {
  margin-bottom: 0;

  :not(:last-child) {
    margin-right: 0.5em;
  }
}
</style>
